import Axios from 'axios';

const RESOURCE = '/api/users';

export default {
  /**
  * Create a new user
  * @param {object} data - User properties
  */
  createUser(data) {
    return Axios.post(RESOURCE, data);
  },

  /**
  * Get Current Logged In User
  * API middleware extracts user from auth header
  */
  getMe() {
    return Axios.get(`${RESOURCE}/me`);
  },

  /**
  * Get User By Id
  * Admin only
  */
  getUser(id) {
    return Axios.get(`${RESOURCE}/${id}`);
  },

  /**
  * Change Email Preferences
  * @param {string} user.id
  * @param {object} preferences - e.g. { emailOptOut: true }
  */
  updateUserEmailPreferences(id, preferences) {
    return Axios.put(`${RESOURCE}/${id}/email`, preferences);
  },

  /**
  * Change Email Address
  * Same as email prefs - need to consolidate
  * @param {string} user.id
  * @param {object} email - e.g. { email: 'string' }
  */
  updateUserEmail(id, email) {
    return Axios.put(`${RESOURCE}/${id}/email`, email);
  },

  /**
  * Change Password
  * @param {string} user.id
  */
  updateUserPassword(id, { oldPassword, newPassword }) {
    return Axios.put(`${RESOURCE}/${id}/password`, { oldPassword, newPassword });
  },

  /**
  * Create new job
  * @param {string} user.id - User Identifier
  */
  createJob(id, data) {
    return Axios.post(`${RESOURCE}/${id}/jobs`, data);
  },

  /**
  * Get user jobs
  * @param {string} user.id
  */
  getJobs(id) {
    return Axios.get(`${RESOURCE}/${id}/jobs`);
  },

  /**
  * Get user themes
  * @param {string} user.id
  */
  getThemes(id) {
    return Axios.get(`${RESOURCE}/${id}/themes`);
  },

  /**
  * Get user billing status
  * @param {string} user.id
  */
  getBillingStatus(id) {
    return Axios.get(`${RESOURCE}/${id}/billing`);
  },

  /**
  * Create new Stripe customer
  * @param {object} req.body - plan
  */
  createStripeCustomer(id, data) {
    return Axios.post(`${RESOURCE}/${id}/billing`, data);
  },

  /**
  * Add subscription for Stripe customer
  * @param {object} req.body - plan
  */
  createSubscription(id, data) {
    return Axios.post(`${RESOURCE}/${id}/billing/subscribe`, data);
  },

  /**
  * Edit billing/ subscription for Stripe customer
  * Specify event of 'changePlan' or 'updatePayment'
  * @param {object} req.body - event, plan, stripe token
  */
  updateBilling(id, data) {
    return Axios.put(`${RESOURCE}/${id}/billing`, data);
  },

  /**
  * Add coupon to Stripe customer's account
  * @param {object} req.body - coupon
  */
  applyDiscount(id, data) {
    return Axios.post(`${RESOURCE}/${id}/billing/discount`, data);
  },

  /**
  * Add coupon to Stripe customer's account
  * @param {object} req.body - coupon
  */
  verifyCoupon(id) {
    return Axios.get(`/api/users/billing/discount/${id}`);
  },

  /**
  * Request Reset
  * @param {object} - { email: 'string', newPassword: 'string }
  */
  createResetRequest(data) {
    return Axios.post('/auth/reset', data);
  },

  /**
  * Confirm New Password
  * @param {object} - { resetToken: jwt }
  */
  confirmPasswordReset(resetToken) {
    return Axios.post('/auth/confirm', { resetToken });
  }

}
